import { TipsInfoMobile } from './TipsInfoMobile'

export const TipsInfo = (props: any) => {
  return (
    <>
      <TipsInfoMobile {...props} />
    </>
  )
}
